export default __webpack_public_path__ + "static/media/3.a0f7bd4c.webp";